import * as React from "react";
import classes from "./settings.module.css"

const Settings = () => {
	return (
		<div className={classes.settings}>Settings</div>
	)
}

export default Settings